// @ts-check
import React from 'react';
import SearchLogoSrc from 'agent_portal/components/NewReferralTypeModal/ChooseNetwork/aristamd_search.svg';

const NetworkLogo = ({ network }) => {
  if (network.usePreferralLogo)
    return <img src={SearchLogoSrc} style={{ width: 198 }} alt="logo" />;
  // return null;
  if (network.logoUrl) return <img src={network.logoUrl} alt="logo" />;
  return null;
};

export default NetworkLogo;
